import { render } from "./DispositivoSicurezzaDettaglio.vue?vue&type=template&id=12353492"
import script from "./DispositivoSicurezzaDettaglio.vue?vue&type=script&lang=js"
export * from "./DispositivoSicurezzaDettaglio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__